import { render } from "./HistoryInput.vue?vue&type=template&id=660e3140&scoped=true"
import script from "./HistoryInput.vue?vue&type=script&lang=js"
export * from "./HistoryInput.vue?vue&type=script&lang=js"

import "./HistoryInput.vue?vue&type=style&index=0&id=660e3140&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-660e3140"]])

export default __exports__